import DirectBookingMfe from './direct-booking-mfe';
export default DirectBookingMfe;
